import type { Notification, NotificationSettings } from '@testflow/shared';
import { request } from './api.js';

export const notificationsApi = {
  list: (): Promise<Notification[]> => request<Notification[]>('/v1/notifications'),
  markRead: (id: string): Promise<void> =>
    request<void>(`/v1/notifications/${id}/read`, { method: 'POST' }),
  getSettings: (): Promise<NotificationSettings> =>
    request<NotificationSettings>('/v1/me/notification-settings'),
  patchSettings: (patch: Partial<NotificationSettings>): Promise<NotificationSettings> =>
    request<NotificationSettings>('/v1/me/notification-settings', {
      method: 'PATCH',
      body: JSON.stringify(patch),
    }),
  // #129: meldet die UI-Sprache an den Server (Sprache der Tester-Digest-Mail). 204 ohne Body.
  setLanguage: (language: 'de' | 'en'): Promise<void> =>
    request<void>('/v1/me/language', {
      method: 'PUT',
      body: JSON.stringify({ language }),
    }),
};
